import React, { useState } from "react";
import Card from "components/card";
import { MdClose, MdSearch } from "react-icons/md";
import { FaHotel } from "react-icons/fa";

const HotelSearchModal = ({ isOpen, onClose, onSearch }) => {
  const [searchData, setSearchData] = useState({
    location: "",
    checkIn: "",
    checkOut: "",
    guests: "1",
    rooms: "1"
  });

  const handleInputChange = (field, value) => {
    setSearchData(prev => ({ ...prev, [field]: value }));
  };

  const handleSearch = () => {
    onSearch(searchData);
    onClose();
  };

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-[9999] flex items-center justify-center bg-black bg-opacity-60 backdrop-blur-sm">
      <Card extra="w-[500px] bg-white/95 dark:bg-navy-800/95 backdrop-blur-sm border border-white/20 dark:border-navy-600/50 shadow-2xl">
        <div className="bg-[#5a88c6] shadow-lg p-6 rounded-t-[20px] relative overflow-hidden">
          <div className="absolute top-0 right-0 w-32 h-32 bg-white/10 rounded-full -translate-y-16 translate-x-16"></div>
          <div className="relative z-10 flex items-center justify-between">
            <div className="flex items-center space-x-3">
              <div className="rounded-2xl bg-white/20 backdrop-blur-sm p-3">
                <FaHotel className="h-6 w-6 text-white" />
              </div>
              <div>
                <h3 className="text-2xl font-bold text-white">Search Hotels</h3>
                <p className="text-white/80 text-sm">Find the perfect accommodation</p>
              </div>
            </div>
            <button onClick={onClose} className="rounded-full bg-white/20 p-2 text-white hover:bg-white/30 transition-colors">
              <MdClose className="h-6 w-6" />
            </button>
          </div>
        </div>
        
        <div className="p-6 space-y-4">
          <div>
            <label className="block text-sm font-semibold text-slate-700 dark:text-white mb-2">Location</label>
            <input
              type="text"
              value={searchData.location}
              onChange={(e) => handleInputChange('location', e.target.value)}
              placeholder="Enter city or hotel name"
              className="w-full px-4 py-3 border border-slate-200 dark:border-navy-600 bg-white dark:bg-navy-800 text-slate-900 dark:text-white rounded-xl text-sm focus:border-purple-500 focus:outline-none transition-colors"
            />
          </div>
          
          <div className="grid grid-cols-2 gap-4">
            <div>
              <label className="block text-sm font-semibold text-slate-700 dark:text-white mb-2">Check-in Date</label>
              <input
                type="date"
                value={searchData.checkIn}
                onChange={(e) => handleInputChange('checkIn', e.target.value)}
                className="w-full px-4 py-3 border border-slate-200 dark:border-navy-600 bg-white dark:bg-navy-800 text-slate-900 dark:text-white rounded-xl text-sm focus:border-purple-500 focus:outline-none transition-colors"
              />
            </div>
            <div>
              <label className="block text-sm font-semibold text-slate-700 dark:text-white mb-2">Check-out Date</label>
              <input
                type="date"
                value={searchData.checkOut}
                onChange={(e) => handleInputChange('checkOut', e.target.value)}
                className="w-full px-4 py-3 border border-slate-200 dark:border-navy-600 bg-white dark:bg-navy-800 text-slate-900 dark:text-white rounded-xl text-sm focus:border-purple-500 focus:outline-none transition-colors"
              />
            </div>
          </div>
          
          <div className="grid grid-cols-2 gap-4">
            <div>
              <label className="block text-sm font-semibold text-slate-700 dark:text-white mb-2">Guests</label>
              <select
                value={searchData.guests}
                onChange={(e) => handleInputChange('guests', e.target.value)}
                className="w-full px-4 py-3 border border-slate-200 dark:border-navy-600 bg-white dark:bg-navy-800 text-slate-900 dark:text-white rounded-xl text-sm focus:border-purple-500 focus:outline-none transition-colors"
              >
                <option value="1">1 Guest</option>
                <option value="2">2 Guests</option>
                <option value="3">3 Guests</option>
                <option value="4">4 Guests</option>
                <option value="5">5+ Guests</option>
              </select>
            </div>
            <div>
              <label className="block text-sm font-semibold text-slate-700 dark:text-white mb-2">Rooms</label>
              <select
                value={searchData.rooms}
                onChange={(e) => handleInputChange('rooms', e.target.value)}
                className="w-full px-4 py-3 border border-slate-200 dark:border-navy-600 bg-white dark:bg-navy-800 text-slate-900 dark:text-white rounded-xl text-sm focus:border-purple-500 focus:outline-none transition-colors"
              >
                <option value="1">1 Room</option>
                <option value="2">2 Rooms</option>
                <option value="3">3 Rooms</option>
                <option value="4">4+ Rooms</option>
              </select>
            </div>
          </div>
          
          <div className="flex space-x-3 pt-4">
            <button
              onClick={onClose}
              className="flex-1 px-6 py-3 border border-slate-300 dark:border-navy-600 text-slate-700 dark:text-white rounded-xl font-semibold hover:bg-slate-50 dark:hover:bg-navy-700 transition-colors"
            >
              Cancel
            </button>
            <button
              onClick={handleSearch}
              className="flex-1 px-6 py-3 bg-[#5a88c6] text-white rounded-xl font-semibold hover:bg-[#4a7bb6] transition-all duration-200 flex items-center justify-center space-x-2"
            >
              <MdSearch className="h-5 w-5" />
              <span>Search Hotels</span>
            </button>
          </div>
        </div>
      </Card>
    </div>
  );
};

export default HotelSearchModal;